// import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// import { FormControl, FormGroup, Validators } from '@angular/forms';
// import indiaStates from '../../../../../../../assets/js/india.state.list.json';
// import { Observable } from 'rxjs';
// import { map, startWith } from 'rxjs/operators';
// import { StorageService } from 'src/app/Services/storage.service';
// import { ApiService } from 'src/app/Services/api.service';
// import { ActivatedRoute, Router } from '@angular/router';
// import { SweetAlert } from 'src/app/Services/sweetalet.service';
// import { LoaderService } from 'src/app/Services/loader.service';
// import { FileUploadService } from 'src/app/Services/file-upload.service';
// import { CommonServices } from 'src/app/Services/common.service';

// export interface User {
//   name: string;
// }
// declare const Compressor;
// @Component({
//   selector: 'app-editdriver',
//   templateUrl: './editdriver.component.html',
//   styleUrls: ['./editdriver.component.css']
// })
// export class EditdriverComponent implements OnInit {

//   public breadcrumbData = {
//     "Information": "/organization/transport-manager/information",
//     "Vendors": "/organization/transport-manager/information/vendor/view-vendor",
//   };

//   matFormSize = '13px';
//   public editDriverForm: FormGroup;
//   public orgID;
//   public vendorID;
//   public driverID;
//   public driverData;
//   public enableForm: boolean=false = false;
//   myControl = new FormControl();
//   public stateSelect = indiaStates.IND;
//   options: User[] = [];
//   public stateData = [];
//   filteredOptions: Observable<User[]>;
//   public userData: any;
//   public imageField;
//   public updateValues = [];

//   public finalCheck: boolean=false = false;
//   routerLinks: any;

//   public branchInformation: any = [];
//   public branchlists = [];
//   public shiftInformation: any = [];
//   public shiftlists = [];
//   public imageUrl;
//   public viewOption: any;

//   licenceImage: File | string = undefined;
//   licencePreview: string | null = null;
//   licenceUploadContentFile: string | undefined = undefined;
//   @ViewChild('licence') licence: ElementRef;

//   profileImage: File | string = undefined;
//   profilePreview: string | null = null;
//   profileContentFile: string | undefined = undefined;
//   @ViewChild('profile') profile: ElementRef;

//   addressProof: File | string = undefined;
//   addressProofPreview: string | null = null;
//   addressContentFile: string | undefined = undefined;
//   @ViewChild('address') address: ElementRef;

//   policeCertficate: File | string = undefined;
//   policeCertficatePreview: string | null = null;
//   policeCertficateContentFile: string | undefined = undefined;
//   @ViewChild('policeCert') policeCert: ElementRef;

//   resume: File | string = undefined;
//   resumePreview: string | null = null;
//   resumeContentFile: string | undefined = undefined;
//   @ViewChild('resum') resum: ElementRef;

//   antecedentReport: File | string = undefined;
//   antecedentReportPreview: string | null = null;
//   antecedentContentFile: string | undefined = undefined;
//   @ViewChild('antecedent') antecedent: ElementRef;

//   resumeUpdate: boolean=false;
//   policeCertficateUpdate: boolean=false;
//   addressUpdate: boolean=false;
//   licenceUpdate: boolean=false;
//   profileUpdate: boolean=false;
//   antecedentReportUpdate:boolean=false;

//   constructor(
//     public api: ApiService,
//     public storage: StorageService,
//     public router: Router,
//     public swal: SweetAlert,
//     private loader: LoaderService,
//     public route: ActivatedRoute,
//     public file: FileUploadService,
//     public comService: CommonServices,
//   ) {
//     this.orgID = this.storage.get('userInfo').orgID;
//     let vendorName = this.storage.get('vendorID_orgID')['vendorName'];

//     this.route.paramMap.subscribe((params: any) => {
//       this.vendorID = params.params.vendorID;
//       this.driverID = params.params.driverID;
//       if (params.params['view']) this.viewOption = params.params.view;

//       if (vendorName) {
//         vendorName = this.comService.strTruncate(vendorName, 13);
//         this.breadcrumbData[vendorName] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
//       } else {
//         this.breadcrumbData['Vendor'] = "/organization/transport-manager/information/vendor/single-view-vendor/" + this.vendorID;
//       }
//       this.breadcrumbData['Drivers'] = "organization/transport-manager/information/driver/view-driver/" + this.vendorID;
//       this.breadcrumbData['Edit'] = "";

//     });

//     this.routerLinks = "/organization/transport-manager/information/driver/view-driver/" + this.vendorID;
//   }

//   ngOnInit(): void {
//     this.addFormLoad();
//     this.filteredOptions = this.myControl.valueChanges
//       .pipe(
//         startWith(''),
//         map(value => typeof value === 'string' ? value : value.name),
//         map(name => name ? this._filter(name) : this.options.slice())
//       );
//     this.getListShift();
//     this.getBranchList();
//     this.loader.show();
//     setTimeout(() => { this.loader.hide(); this.getDriverData(); }, 500);

//     this.getStateOptions();
//   }

//   //shift
//   async getListShift() {
//     const obj = {
//       orgID: this.storage.get('userInfo').orgID
//     };
//     await this.api.ListShift(obj).then((res: any) => {
//       if (res.status == 'success') {
//         this.shiftInformation = res.data;
//       }
//     }).catch((err) => {
//       console.log(err);
//     });
//   }
//   //branch
//   async getBranchList() {
//     const obj = {
//       orgID: this.storage.get('userInfo').orgID
//     };
//     await this.api.transportManagerBranchList(obj).then((res: any) => {
//       if (res.status == 'success') {
//         this.branchInformation = res.data;
//         this.branchlists = res.data.map(item => {
//           return {
//             "name": item.branchName, value: item.branchID,
//           }
//         });
//       }
//     }).catch((err) => {
//       console.log(err);
//     });
//   }
//   /*Get Driver data*/

//   getDriverData() {
//     const obj = {
//       orgID: this.orgID,
//       vendorID: this.vendorID,
//       driverID: this.driverID
//     };
//     this.api.transportManagerDriverList(obj).then((res: any) => {
//       if (res.status == 'success') {
//         this.driverData = res.data[0];
//         const data = res.data[0];
//         if (data.branch) this.getShiftFieldData(data.branch);
//         this.setValueEditDriverForm(data);
//         // this.swal.swalFunction(res.status, res.status, res.message, 2000)

//       }
//     }).catch((err) => {
//       console.log(err);
//     });
//   }
//   setValueEditDriverForm(data) {
//     this.editDriverForm.patchValue({
//       address: data['address'] ? data['address'] : '',
//       bloodGroup: data['bloodGroup'] ? data['bloodGroup'] : '',
//       city: data['city'] ? data['city'] : '',
//       country: data['country'] ? data['country'] : 'India',
//       dob: data['dob'] ? new Date(data['dob']) : '',
//       emergencyContact: data['emergencyContact'] ? data['emergencyContact'] : '',
//       licenceExpiry: data['licenceExpiry'] ? new Date(data['licenceExpiry']) : '',
//       licenceNo: data['licenceNo'] ? data['licenceNo'] : '',
//       licenceUpload: data['licence'] ? data['licence'] : '',
//       mobile: data['mobile'] ? data['mobile'] : '',
//       name: data['name'] ? data['name'] : '',
//       pincode: data['pincode'] ? data['pincode'] : '',
//       profilePic: data['profilePic'] ? data['profilePic'] : '',
//       state: data['state'] ? data['state'] : '',
//       branch: data['branch'] ? data['branch'] : '',
//       shift: data['shift'] ? data['shift'] : '',
//       addressProof: data['addressProof'] ? data['addressProof'] : '',
//       policeCertficate: data['resume'] ? data['resume'] : '',
//       resume: data['resume'] ? data['resume'] : ''
//     });

//     (data['profilePic'] && data['profilePic'] != '') && (data['profileContentFile'] != undefined) ? this.profileContentFile = data['profileContentFile'] : data['profileContentFile'] == undefined ? this.profileContentFile = 'Image' : '';
//     data['addressProof'] && data['addressProof'] != '' && (data['addressContentFile'] != undefined) ? this.addressContentFile = data['addressContentFile'] : data['addressContentFile'] == undefined ? this.addressContentFile = 'Image' : '';
//     data['resume'] && data['resume'] != '' && (data['resumeContentFile'] != undefined) ? this.resumeContentFile = data['resumeContentFile'] : data['resumeContentFile'] == undefined ? this.resumeContentFile = 'Image' : '';
//     data['policeCertficate'] && data['policeCertficate'] != '' && (data['policeCertficateContentFile']) ? this.policeCertficateContentFile = data['policeCertficateContentFile'] : data['policeCertficateContentFile'] == undefined ? this.policeCertficateContentFile = 'Image' : '';
//     data['licenceUpload'] && data['licenceUpload'] != '' && (data['licenceUploadContentFile']) ? this.licenceUploadContentFile = data['licenceUploadContentFile'] : data['licenceUploadContentFile'] == undefined ? this.licenceUploadContentFile = 'Image' : '';
//     data['antecedentReport'] && data['antecedentReport'] != '' && (data['antecedentContentFile']) ? this.antecedentContentFile = data['antecedentContentFile'] : data['antecedentContentFile'] == undefined ? this.antecedentContentFile = 'Image' : '';

//     this.profileImage = this.profilePreview = data['profilePic'] ? data['profilePic'] + '?ts=' + Date.now() : '';
//     this.policeCertficate = this.policeCertficatePreview = data['policeCertficate'] && data['policeCertficate'] !== '' ? data['policeCertficate'] + '?ts=' + Date.now() : '';
//     const licenceSource = data['licenceUpload'] !== '' ? data['licenceUpload'] : data['licence'] !== undefined ? data['licence'] : '';
//     this.licenceImage = this.licencePreview = licenceSource ? licenceSource + '?ts=' + Date.now() : '';
//     this.addressProof = this.addressProofPreview = data['addressfiles'] && data['addressfiles'] !== '' ? data['addressfiles'] + '?ts=' + Date.now() : data['addressProof'] ? data['addressProof'] + '?ts=' + Date.now() : '';
//     this.resume = this.resumePreview = data['resumefiles'] && data['resumefiles'] !== '' ? data['resumefiles'] + '?ts=' + Date.now() : data['resume'] ? data['resume'] + '?ts=' + Date.now() : '';
//     this.antecedentReport = this.antecedentReportPreview = data['antecedentReport'] && data['antecedentReport'] !== '' ? data['antecedentReport'] + '?ts=' + Date.now() :  '';
//     this.enableForm = true;
//   }
//   getStateOptions() {
//     this.stateSelect.forEach(element => {
//       //console.log(element)
//       this.options.push({ name: element })
//     });
//     // console.log(this.options);
//   }
//   addFormLoad() {
//     this.editDriverForm = new FormGroup({
//       name: new FormControl('', [Validators.required]),
//       dob: new FormControl(''), /* , [Validators.required]), */
//       licenceNo: new FormControl('', [Validators.required]),
//       licenceExpiry: new FormControl(''), /* [Validators.required]), */
//       branch: new FormControl('', [Validators.required]),
//       shift: new FormControl('', [Validators.required]),
//       mobile: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
//       emergencyContact: new FormControl('', [/* Validators.required, */Validators.pattern('[0-9]\\d{9}')]),
//       bloodGroup: new FormControl(''), /*  [Validators.required]), */
//       address: new FormControl(''), /* [Validators.required]), */
//       city: new FormControl(''), /* [Validators.required]), */
//       state: new FormControl(''), /* [Validators.required]), */
//       country: new FormControl('India'),
//       pincode: new FormControl('', [/* Validators.required,  */Validators.pattern('[0-9]\\d{5}')]),
//       profilePic: new FormControl(''), /* ,[Validators.required]), */
//       licenceUpload: new FormControl('') /* , [Validators.required]), */,
//       addressProof: new FormControl(''),
//       policeCertficate: new FormControl(''),
//       resume: new FormControl(''),
//       antecedentReport: new FormControl(''),
//     });
//     if (this.viewOption == 'view') {
//       const controlNames = Object.keys(this.editDriverForm.controls);
//       controlNames.forEach(controlName => {
//         this.editDriverForm.get(controlName)?.disable();
//       });
//     }
//     this.editDriverForm.controls.country.disable();
//   }
//   public checkError = (controlName: string, errorName: string) => {
//     return this.editDriverForm.controls[controlName].hasError(errorName);
//   }
//   private _filter(name: string): User[] {
//     const filterValue = name.toLowerCase();

//     return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
//   }
//   getBranchResult(selected) {
//     this.getShiftFieldData(selected.value);
//     this.fieldChange(selected, 'dropdown', 'branch');

//   }
//   getShiftFieldData(values) {
//     this.shiftlists = [];
//     if (!Array.isArray(values)) values = [values];
//     this.shiftInformation.map((item) => {
//       let obj = {
//         name: item.shiftName,/* +' - '+ this.getName(item.branch,this.branchInformation,'branchID','branchName'),*/
//         value: item.shiftID
//       };
//       if (item.branch && values.includes(item.branch)) this.shiftlists.push(obj);

//     })
//   }

//   getName(id, data, key, returnValue) {
//     let result = '';
//     if (!Array.isArray(data)) data = [data];
//     data.filter((item) => {
//       if (item[key] == id) {
//         result = item[returnValue];
//       }
//     })
//     return result;
//   }

//   _keyPress(event: any) {
//     const pattern = /[0-9]/;
//     const inputChar = String.fromCharCode(event.charCode);
//     if (!pattern.test(inputChar)) {
//       event.preventDefault();

//     }
//   }
//   displayFn(user: User): string {
//     this.stateData = [];
//     this.stateData.push(user);
//     //this.editDriverForm.value.patchValue({state:user});
//     return user && user.name ? user.name : '';
//   }
//   /*clear image file*/
//   clkFun(field) {
//     this.editDriverForm.controls[field].patchValue('');
//     const feildMapping: { [key: string]: string } = {
//       profilePic: 'profilePic', licenceUpload: 'licenceUpload',
//       addressProof: 'addressProof', policeCertficate: 'policeCertficate',
//       resume: 'resume'
//     }
//     const mappedField = feildMapping[field];
//     if (mappedField.length > 0) { this[mappedField] = '' };
//   }

//   // async handleUpload(event, field) {
//   //   let base64;

//   //   if (field == 'licenceUpload') {
//   //     this.licenceImage = await this.file.fileHandeleBase64(event);
//   //     base64 = this.licenceImage;
//   //   }
//   //   if (field == 'profilePic') {
//   //     this.profileImage = await this.file.fileHandeleBase64(event);
//   //     base64 = this.profileImage;
//   //   } if (field == 'addressProof') {
//   //     this.addressProof = await this.file.fileHandeleBase64(event);
//   //     base64 = this.addressProof;
//   //   } if (field == 'policeCertficate') {
//   //     this.policeCertficate = await this.file.fileHandeleBase64(event);
//   //     base64 = this.policeCertficate;
//   //   } if (field == 'resume') {
//   //     this.resume = await this.file.fileHandeleBase64(event);
//   //     base64 = this.resume;
//   //   }
//   //   this.editDriverForm.controls[field].patchValue(base64);
//   //   this.updateField(field, base64);
//   // }

//   // reUpload(field) {
//   //   document.getElementById(field).click();
//   // }

//   async handleUpload(event: Event, type: string) {
//     const file = (event.target as HTMLInputElement).files?.[0];
//     const maxFileSizeInMB = 1;
//     const maxFileSize = maxFileSizeInMB * 1024 * 1024;
//     const allowedImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
//     const allowedPdfType = 'application/pdf';

//     if (!file) return;

//     const fileType = file.type;
//     const isImageOrPdf = allowedImageTypes.includes(fileType) || fileType === allowedPdfType;

//     if (!isImageOrPdf) {
//       this.handleInvalidFileType(type);
//       return this.showErrorMessage('Invalid file type. Only images and PDFs are allowed.');
//     }

//     if (file.size > maxFileSize) {
//       this.handleFileSizeExceeded(type);
//       return this.showErrorMessage(`File size exceeds ${maxFileSizeInMB} MB`);
//     }

//     this.processFile(file, type, fileType, allowedImageTypes.includes(fileType) ? 'Image' : 'PDF');

//     // if (this.formSubmit) this.validation();
//   }

//   private processFile(file: File, type: string, fileType: string, contentType: string) {
//     const fileReader = new FileReader();
//     fileReader.onload = () => this.updateFormAndPreview(type, file, fileReader.result as string, contentType);
//     fileReader.readAsDataURL(file);
//   }

//   private updateFormAndPreview(type: string, file: File, previewData: string, contentType: string) {
//     switch (type) {
//       case 'profilePic':
//         this.profileImage = file;
//         this.profilePreview = previewData;
//         this.profileContentFile = contentType;
//         // this.updateField('profile', this.profilePreview)
//         this.profileUpdate=true;
//         this.editDriverForm.controls.profilePic.patchValue(file);
//         break;
//       case 'licenceUpload':
//         this.licenceImage = file;
//         this.licenceUploadContentFile = contentType;
//         this.licencePreview = previewData;
//         // this.updateField('profile', this.profilePreview)
//         this.licenceUpdate=true;
//         this.editDriverForm.controls.licenceUpload.patchValue(file);
//         break;
//       case 'addressProof':
//         this.addressProof = file;
//         this.addressContentFile = contentType;
//         this.addressProofPreview = previewData;
//         // this.updateField('addressfiles', this.addressProofPreview)
//         this.addressUpdate=true;
//         this.editDriverForm.controls.addressProof.patchValue(file);
//         break;
//       case 'policeCertficate':
//         this.policeCertficate = file;
//         this.policeCertficateContentFile = contentType;
//         this.policeCertficatePreview = previewData;
//         this.policeCertficateUpdate=true;
//         this.editDriverForm.controls.policeCertficate.patchValue(file);
//         break;
//       case 'resume':
//         this.resume = file;
//         this.resumeContentFile = contentType;
//         this.resumePreview = previewData;
//         // this.updateField('resumefiles', this.resumePreview)
//         this.resumeUpdate=true;
//         this.editDriverForm.controls.resume.patchValue(file);
//         break;
//          case 'antecedentReport':
//         this.antecedentReport = file;
//         this.antecedentContentFile = contentType;
//         this.antecedentReportPreview = previewData;
//         this.antecedentReportUpdate = true;
//         this.editDriverForm.controls.antecedentReport.patchValue(file);
//         break;
//     }
//   }

//   private handleInvalidFileType(type: string) {
//     this.resetFileFields(type);
//   }

//   private handleFileSizeExceeded(type: string) {
//     this.resetFileFields(type);
//   }

//   private resetFileFields(type: string) {
//     switch (type) {
//       case 'profilePic':
//         this.profileImage = null;
//         this.profilePreview = null;
//         this.profileContentFile = null;
//         this.editDriverForm.controls.profilePic.reset();
//         this.clearInputField(this.profile);
//         break;
//       case 'licenceUpload':
//         this.licenceImage = null;
//         this.licencePreview = null;
//         this.licenceUploadContentFile = null;
//         this.editDriverForm.controls.licenceUpload.reset();
//         this.clearInputField(this.licence);
//         break;
//       case 'addressProof':
//         this.addressProof = null;
//         this.addressProofPreview = null;
//         this.addressContentFile = null;
//         this.editDriverForm.controls.addressProof.reset();
//         this.clearInputField(this.address);
//         break;
//       case 'policeCertficate':
//         this.policeCertficate = null;
//         this.policeCertficatePreview = null;
//         this.policeCertficateContentFile = null;
//         this.editDriverForm.controls.policeCertficate.reset();
//         this.clearInputField(this.policeCert);
//         break;
//       case 'resume':
//         this.resume = null;
//         this.resumePreview = null;
//         this.resumeContentFile = null;
//         this.editDriverForm.controls.resume.reset();
//         this.clearInputField(this.resum);
//         break;
//         case 'antecedentReport':
//           this.antecedentReport = null;
//           this.antecedentReportPreview = null;
//           this.antecedentContentFile = null;
//           this.editDriverForm.controls.antecedentReport.reset();
//           this.clearInputField(this.antecedent)
//          break;
//     }
//   }

//   private clearInputField(inputElement: ElementRef) {
//     if (inputElement) inputElement.nativeElement.value = '';
//   }

//   private showErrorMessage(message: string) {
//     this.swal.swalFunction('error', 'error', message, 5000);
//   }

//   reUpload(field: string) {
//     const fileFieldMap = {
//       'profile': this.profile,
//       'licence': this.licence,
//       'address': this.address,
//       'policeCert': this.policeCert,
//       'resum': this.resum,
//       'antecedent': this.antecedent
//     };

//     const fileInput = fileFieldMap[field];
//     if (fileInput) {
//       fileInput.nativeElement.click();
//     }
//   }

//   cancelImage(type: string) {
//     if (type == 'profile') {
//       this.editDriverForm.controls.profilePic.patchValue('');
//       this.profileImage = undefined;
//     } if (type == 'licenceUpload') {
//       this.editDriverForm.controls.licenceUpload.patchValue('');
//       this.licenceImage = undefined;
//     } if (type == 'addressProof') {
//       this.editDriverForm.controls.addressProof.patchValue('');
//       this.addressProof = undefined;
//     } if (type == 'policeCertficate') {
//       this.editDriverForm.controls.policeCertficate.patchValue('');
//       this.policeCertficate = undefined;
//     } if (type == 'resume') {
//       this.editDriverForm.controls.resume.patchValue('');
//       this.resume = undefined;
//     }if (type == 'antecedentReport') {
//       this.editDriverForm.controls.antecedentReport.patchValue('');
//       this.antecedentReport = undefined;
//     }
//   }

//   /*update field*/
//   fieldChange(e: any, type, field) {
//     if (type == 'text' || type == 'textarea' || type == 'number') {
//       let value = e.target.value;
//       if ((field == 'mobile' || field == 'emergencyContact') && value != '') value = parseInt(value);
//       this.updateField(field, value);
//     }
//     if (type == 'date') {
//      let value = new Date(e.value).getTime();
//       this.updateField(field, value);
//     }
//     if (type == 'dropdown') {
//        this.updateField(field, e.value);
//      }
//     if (type == 'file') {
//       // console.log(e);
//       //this.fileUpload(e,field);
//     }
//     if (type == 'option') {
//       // console.log(e.option.value.name);
//     }
//   }
//   updateField(field, value) {
//     if (this.updateValues.length > 0) {
//       let filterUpdate = this.updateValues.filter((e) => e.field != field);
//       let obj = { field: field, value: value, };
//       this.updateValues = [
//         ...filterUpdate,
//         obj,
//       ]
//     }
//     else {
//       let obj = { field: field, value: value, };
//       this.updateValues.push(obj);
//     }
//   }

//   onSubmit() {
//     this.finalCheck = true;
//     if (this.updateValues.length > 0 && this.editDriverForm.valid ||this.policeCertficateUpdate == true || this.profileUpdate== true || this.licenceUpdate == true || this.addressUpdate == true || this.resumeUpdate == true || this.antecedentReportUpdate == true) {
//       const obj = {
//         orgID: this.orgID,
//         vendorID: this.vendorID,
//         driverID: this.driverID,
//       };
//       this.updateValues.filter((e) => {
//         obj[e.field] = e.value;
//       })
//       if (this.profileImage == undefined || (obj['profilePic'] && obj['profilePic'] == '')) delete obj['profilePic'];

//       if (this.profileUpdate == true) {
//         obj['profile'] = this.profileImage;
//         obj['profileContentFile'] = this.profileContentFile;
//         delete obj['profilePic']
//       } else { delete obj['profilePic'] }

//       if (this.licenceUpdate == true) {
//         obj['licenceUpload'] = this.licenceImage;
//         obj['licenceUploadContentFile'] = this.licenceUploadContentFile;
//       } else { delete obj['licenceUpload'] }

//       if (this.policeCertficateUpdate == true) {
//         obj['policeCertficate'] = this.policeCertficate;
//         obj['policeCertficateContentFile'] = this.policeCertficateContentFile;
//       }
//       else {
//         delete obj['policeCertficate'];
//       }
//       if (this.resumeUpdate == true) {
//         obj['resumefiles'] = this.resume;
//         obj['resumeContentFile'] = this.resumeContentFile;
//         delete obj['resume'];
//       } else {
//         delete obj['resumefiles'];
//         delete obj['resume'];
//       }
//       if (this.addressUpdate == true) {
//         obj['addressfiles'] = this.addressProof;
//         obj['addressContentFile'] = this.addressContentFile;
//         delete obj['addressProof'];
//       } else {
//         delete obj['addressProof'];
//       }
//       if(this.antecedentReportUpdate == true){
//         obj['antecedentReport'] = this.antecedentReport;
//         obj['antecedentContentFile'] = this.antecedentContentFile
//       }
//       let url = 'organization/driver/updateDriver';
//       this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
//         if (res['responseJSON']['status'] == 'success') {
//           this.profileImage = undefined;
//           this.licenceImage = undefined;
//           this.addressProof = undefined;
//           this.policeCertficate = undefined;
//           this.resume = undefined;
//           this.swal.swalFunction(res['responseJSON'].status, res['responseJSON'].status, res['responseJSON'].message, 2000);
//           this.router.navigate(['/organization/transport-manager/information/driver/view-driver', this.vendorID]);
//         }
//         if (res['responseJSON'].status == 'failure') {
//           this.loader.hide();
//           this.swal.swalFunction('error', res['responseJSON'].status, res['responseJSON'].message, 3000);
//         }
//       })
//     }
//     else {
//       if (this.updateValues.length == 0) {
//         this.swal.swalFunction('warning', "warning", "Please make any change and update!", 6000);
//       }
//     }
//   }
//   previewImage(imageUrl) {
//     // this.imageUrl = image;
//     if (imageUrl.startsWith('data:image')) {
//       // Open the base64 image in a new tab
//       const newWindow = window.open();
//       if (newWindow) {
//         newWindow.document.write(`<img src="${imageUrl}" style="width:100%;">`);
//         newWindow.document.title = "Image Preview";
//       }
//     } else {
//       window.open(imageUrl, '_blank');
//     }
//   }

//   openPdf(pdfUrl: string) {
//     if (pdfUrl.startsWith('data:application/pdf;base64,')) {
//       const newWindow = window.open();
//       if (newWindow) {
//         newWindow.document.write(`
//           <html>
//             <head>
//               <title>PDF Preview</title>
//             </head>
//             <body style="margin: 0; padding: 0; overflow: hidden;">
//               <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" />
//             </body>
//           </html>
//         `);
//       }
//     } else {
//       // Handle URL-based PDF
//       window.open(pdfUrl, '_blank');
//     }
//   }
// }
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import indiaStates from "../../../../../../../assets/js/india.state.list.json";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { StorageService } from "src/app/Services/storage.service";
import { ApiService } from "src/app/Services/api.service";
import { ActivatedRoute, Router } from "@angular/router";
import { SweetAlert } from "src/app/Services/sweetalet.service";
import { LoaderService } from "src/app/Services/loader.service";
import { FileUploadService } from "src/app/Services/file-upload.service";
import { CommonServices } from "src/app/Services/common.service";

export interface User {
  name: string;
}
declare const Compressor;
@Component({
  selector: "app-editdriver",
  templateUrl: "./editdriver.component.html",
  styleUrls: ["./editdriver.component.css"],
})
export class EditdriverComponent implements OnInit {
  public breadcrumbData = {
    Information: "/organization/transport-manager/information",
    Vendors: "/organization/transport-manager/information/vendor/view-vendor",
  };

  matFormSize = "13px";
  public editDriverForm: FormGroup;
  public orgID;
  public vendorID;
  public driverID;
  public driverData;
  public enableForm: boolean =  false;
  myControl = new FormControl();
  public stateSelect = indiaStates.IND;
  options: User[] = [];
  public stateData = [];
  filteredOptions: Observable<User[]>;
  public userData: any;
  public imageField;
  public updateValues = [];

  public finalCheck: boolean = false;
  routerLinks: any;

  public branchInformation: any = [];
  public branchlists = [];
  public shiftInformation: any = [];
  public shiftlists = [];
  public imageUrl;
  public viewOption: any;
  public pageTitle: string = "Edit Driver"; // New: switch title between edit/view mode

  licenceImage: File | string = undefined;
  licencePreview: string | null = null;
  licenceUploadContentFile: string | undefined = undefined;
  @ViewChild("licence") licence: ElementRef;

  profileImage: File | string = undefined;
  profilePreview: string | null = null;
  profileContentFile: string | undefined = undefined;
  @ViewChild("profile") profile: ElementRef;

  addressProof: File | string = undefined;
  addressProofPreview: string | null = null;
  addressContentFile: string | undefined = undefined;
  @ViewChild("address") address: ElementRef;

  policeCertficate: File | string = undefined;
  policeCertficatePreview: string | null = null;
  policeCertficateContentFile: string | undefined = undefined;
  @ViewChild("policeCert") policeCert: ElementRef;

  resume: File | string = undefined;
  resumePreview: string | null = null;
  resumeContentFile: string | undefined = undefined;
  @ViewChild("resum") resum: ElementRef;

  antecedentReport: File | string = undefined;
  antecedentReportPreview: string | null = null;
  antecedentContentFile: string | undefined = undefined;
  @ViewChild("antecedent") antecedent: ElementRef;

  resumeUpdate: boolean = false;
  policeCertficateUpdate: boolean = false;
  addressUpdate: boolean = false;
  licenceUpdate: boolean = false;
  profileUpdate: boolean = false;
  antecedentReportUpdate: boolean = false;

  constructor(
    public api: ApiService,
    public storage: StorageService,
    public router: Router,
    public swal: SweetAlert,
    private loader: LoaderService,
    public route: ActivatedRoute,
    public file: FileUploadService,
    public comService: CommonServices,
  ) {
    this.orgID = this.storage.get("userInfo").orgID;
    let vendorName = this.storage.get("vendorID_orgID")["vendorName"];

    this.route.paramMap.subscribe((params: any) => {
      this.vendorID = params.params.vendorID;
      this.driverID = params.params.driverID;
      if (params.params["view"]) this.viewOption = params.params.view;

      if (vendorName) {
        vendorName = this.comService.strTruncate(vendorName, 13);
        this.breadcrumbData[vendorName] =
          "/organization/transport-manager/information/vendor/single-view-vendor/" +
          this.vendorID;
      } else {
        this.breadcrumbData["Vendor"] =
          "/organization/transport-manager/information/vendor/single-view-vendor/" +
          this.vendorID;
      }
      this.breadcrumbData["Drivers"] =
        "organization/transport-manager/information/driver/view-driver/" +
        this.vendorID;
      // OLD:
      // this.breadcrumbData['Edit'] = "";

      // New: switch title and breadcrumb label based on route mode
      if (this.viewOption == "view") {
        this.pageTitle = "View Driver";
        this.breadcrumbData["View"] = "";
      } else {
        this.pageTitle = "Edit Driver";
        this.breadcrumbData["Edit"] = "";
      }
    });

    this.routerLinks =
      "/organization/transport-manager/information/driver/view-driver/" +
      this.vendorID;
  }

  ngOnInit(): void {
    this.addFormLoad();
    this.filteredOptions = this.myControl.valueChanges.pipe(
      startWith(""),
      map((value) => (typeof value === "string" ? value : value.name)),
      map((name) => (name ? this._filter(name) : this.options.slice())),
    );
    this.getListShift();
    this.getBranchList();
    this.loader.show();
    setTimeout(() => {
      this.loader.hide();
      this.getDriverData();
    }, 500);

    this.getStateOptions();
  }

  //shift
  async getListShift() {
    const obj = {
      orgID: this.storage.get("userInfo").orgID,
    };
    await this.api
      .ListShift(obj)
      .then((res: any) => {
        if (res.status == "success") {
          this.shiftInformation = res.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  //branch
  async getBranchList() {
    const obj = {
      orgID: this.storage.get("userInfo").orgID,
    };
    await this.api
      .transportManagerBranchList(obj)
      .then((res: any) => {
        if (res.status == "success") {
          this.branchInformation = res.data;
          this.branchlists = res.data.map((item) => {
            return {
              name: item.branchName,
              value: item.branchID,
            };
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  /*Get Driver data*/

  getDriverData() {
    const obj = {
      orgID: this.orgID,
      vendorID: this.vendorID,
      driverID: this.driverID,
    };
    this.api
      .transportManagerDriverList(obj)
      .then((res: any) => {
        console.log(res);
        if (res.status == "success") {
          this.driverData = res.data[0];
          const data = res.data[0];
          if (data.branch) this.getShiftFieldData(data.branch);
          this.setValueEditDriverForm(data);
          // this.swal.swalFunction(res.status, res.status, res.message, 2000)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }
  setValueEditDriverForm(data) {
    this.editDriverForm.patchValue({
      address: data["address"] ? data["address"] : "",
      bloodGroup: data["bloodGroup"] ? data["bloodGroup"] : "",
      city: data["city"] ? data["city"] : "",
      country: data["country"] ? data["country"] : "India",
      dob: data["dob"] ? new Date(data["dob"]) : "",
      emergencyContact: data["emergencyContact"]
        ? data["emergencyContact"]
        : "",
      licenceExpiry: data["licenceExpiry"]
        ? new Date(data["licenceExpiry"])
        : "",
      licenceNo: data["licenceNo"] ? data["licenceNo"] : "",
      licenceUpload: data["licence"] ? data["licence"] : "",
      mobile: data["mobile"] ? data["mobile"] : "",
      name: data["name"] ? data["name"] : "",
      pincode: data["pincode"] ? data["pincode"] : "",
      profilePic: data["profilePic"] ? data["profilePic"] : "",
      state: data["state"] ? data["state"] : "",
      branch: data["branch"]
        ? Array.isArray(data["branch"])
          ? data["branch"]
          : [data["branch"]]
        : [],
      shift: data["shift"]
        ? Array.isArray(data["shift"])
          ? data["shift"]
          : [data["shift"]]
        : [],
      //shift: data['shift'] ? data['shift'] : '',
      // isActive: data['isActive'] == 0 ? 'active' :
      //   data['isActive'] == 1 ? 'inactive' :
      //   data['isActive'] == 2 ? 'blocked' : 'active',
      isActive:
        data["isActive"] == "active"
          ? "active"
          : data["isActive"] == "inactive"
            ? "inactive"
            : data["isActive"] == "blocked"
              ? "blocked"
              : data["isActive"] == 0
                ? "active"
                : data["isActive"] == 1
                  ? "inactive"
                  : data["isActive"] == 2
                    ? "blocked"
                    : "active",

      //status: data['status'] ? data['status'] : 'Active',
      addressProof: data["addressProof"] ? data["addressProof"] : "",
      policeCertficate: data["resume"] ? data["resume"] : "",
      resume: data["resume"] ? data["resume"] : "",
    });

    data["profilePic"] &&
    data["profilePic"] != "" &&
    data["profileContentFile"] != undefined
      ? (this.profileContentFile = data["profileContentFile"])
      : data["profileContentFile"] == undefined
        ? (this.profileContentFile = "undefined")
        : "";
    data["addressProof"] &&
    data["addressProof"] != "" &&
    data["addressContentFile"] != undefined
      ? (this.addressContentFile = data["addressContentFile"])
      : data["addressContentFile"] == undefined
        ? (this.addressContentFile = "Image")
        : "";
    data["resume"] &&
    data["resume"] != "" &&
    data["resumeContentFile"] != undefined
      ? (this.resumeContentFile = data["resumeContentFile"])
      : data["resumeContentFile"] == undefined
        ? (this.resumeContentFile = "Image")
        : "";
    data["policeCertficate"] &&
    data["policeCertficate"] != "" &&
    data["policeCertficateContentFile"]
      ? (this.policeCertficateContentFile = data["policeCertficateContentFile"])
      : data["policeCertficateContentFile"] == undefined
        ? (this.policeCertficateContentFile = "Image")
        : "";
    data["licenceUpload"] &&
    data["licenceUpload"] != "" &&
    data["licenceUploadContentFile"]
      ? (this.licenceUploadContentFile = data["licenceUploadContentFile"])
      : data["licenceUploadContentFile"] == undefined
        ? (this.licenceUploadContentFile = "Image")
        : "";
    data["antecedentReport"] &&
    data["antecedentReport"] != "" &&
    data["antecedentContentFile"]
      ? (this.antecedentContentFile = data["antecedentContentFile"])
      : data["antecedentContentFile"] == undefined
        ? (this.antecedentContentFile = "Image")
        : "";

    this.profileImage = this.profilePreview = data["profilePic"]
      ? data["profilePic"] + "?ts=" + Date.now()
      : "";
    this.policeCertficate = this.policeCertficatePreview =
      data["policeCertficate"] && data["policeCertficate"] !== ""
        ? data["policeCertficate"] + "?ts=" + Date.now()
        : "";
    const licenceSource =
      data["licenceUpload"] !== ""
        ? data["licenceUpload"]
        : data["licence"] !== undefined
          ? data["licence"]
          : "";
    this.licenceImage = this.licencePreview = licenceSource
      ? licenceSource + "?ts=" + Date.now()
      : "";
    this.addressProof = this.addressProofPreview =
      data["addressfiles"] && data["addressfiles"] !== ""
        ? data["addressfiles"] + "?ts=" + Date.now()
        : data["addressProof"]
          ? data["addressProof"] + "?ts=" + Date.now()
          : "";
    this.resume = this.resumePreview =
      data["resumefiles"] && data["resumefiles"] !== ""
        ? data["resumefiles"] + "?ts=" + Date.now()
        : data["resume"]
          ? data["resume"] + "?ts=" + Date.now()
          : "";
    this.antecedentReport = this.antecedentReportPreview =
      data["antecedentReport"] && data["antecedentReport"] !== ""
        ? data["antecedentReport"] + "?ts=" + Date.now()
        : "";
    this.enableForm = true;
  }
  getStateOptions() {
    this.stateSelect.forEach((element) => {
      //console.log(element)
      this.options.push({ name: element });
    });
    // console.log(this.options);
  }
  addFormLoad() {
    this.editDriverForm = new FormGroup({
      name: new FormControl("", [Validators.required]),
      dob: new FormControl("", [Validators.required]),
      licenceNo: new FormControl("", [Validators.required]),
      licenceExpiry: new FormControl("", [Validators.required]),
      branch: new FormControl([], [Validators.required]),
      shift: new FormControl("", [Validators.required]),
      isActive: new FormControl("", [Validators.required]),
      mobile: new FormControl("", [
        Validators.required,
        Validators.pattern("[0-9]\\d{9}"),
      ]),
      emergencyContact: new FormControl("", [
        Validators.required,
        Validators.pattern("[0-9]\\d{9}"),
      ]),
      bloodGroup: new FormControl("") /*  [Validators.required]), */,
      address: new FormControl("", [Validators.required]),
      city: new FormControl("", [
        Validators.required,
      ]) /* [Validators.required]), */,
      state: new FormControl("", [
        Validators.required,
      ]) /* [Validators.required]), */,
      country: new FormControl("India"),
      pincode: new FormControl("", [
        Validators.required,
        Validators.pattern("[0-9]\\d{5}"),
      ]),
      profilePic: new FormControl("") /* ,[Validators.required]), */,
      licenceUpload: new FormControl("") /* , [Validators.required]), */,
      addressProof: new FormControl(""),
      policeCertficate: new FormControl(""),
      resume: new FormControl(""),
      antecedentReport: new FormControl(""),
    });
    if (this.viewOption == "view") {
      const controlNames = Object.keys(this.editDriverForm.controls);
      controlNames.forEach((controlName) => {
        this.editDriverForm.get(controlName)?.disable();
      });
    }
    this.editDriverForm.controls.country.disable();
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.editDriverForm.controls[controlName].hasError(errorName);
  };
  private _filter(name: string): User[] {
    const filterValue = name.toLowerCase();

    return this.options.filter((option) =>
      option.name.toLowerCase().includes(filterValue),
    );
  }
  getBranchResult(selected) {
    this.getShiftFieldData(selected.value);
    this.fieldChange(selected, "dropdown", "branch");
  }
  getShiftFieldData(values) {
    this.shiftlists = [];
    if (!Array.isArray(values)) values = [values];
    this.shiftInformation.map((item) => {
      let obj = {
        name: item.shiftName /* +' - '+ this.getName(item.branch,this.branchInformation,'branchID','branchName'),*/,
        value: item.shiftID,
      };
      if (item.branch && values.includes(item.branch))
        this.shiftlists.push(obj);
    });
  }

  getName(id, data, key, returnValue) {
    let result = "";
    if (!Array.isArray(data)) data = [data];
    data.filter((item) => {
      if (item[key] == id) {
        result = item[returnValue];
      }
    });
    return result;
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  displayFn(user: User): string {
    this.stateData = [];
    this.stateData.push(user);
    //this.editDriverForm.value.patchValue({state:user});
    return user && user.name ? user.name : "";
  }
  /*clear image file*/
  clkFun(field) {
    this.editDriverForm.controls[field].patchValue("");
    const feildMapping: { [key: string]: string } = {
      profilePic: "profilePic",
      licenceUpload: "licenceUpload",
      addressProof: "addressProof",
      policeCertficate: "policeCertficate",
      resume: "resume",
    };
    const mappedField = feildMapping[field];
    if (mappedField.length > 0) {
      this[mappedField] = "";
    }
  }

  // async handleUpload(event, field) {
  //   let base64;

  //   if (field == 'licenceUpload') {
  //     this.licenceImage = await this.file.fileHandeleBase64(event);
  //     base64 = this.licenceImage;
  //   }
  //   if (field == 'profilePic') {
  //     this.profileImage = await this.file.fileHandeleBase64(event);
  //     base64 = this.profileImage;
  //   } if (field == 'addressProof') {
  //     this.addressProof = await this.file.fileHandeleBase64(event);
  //     base64 = this.addressProof;
  //   } if (field == 'policeCertficate') {
  //     this.policeCertficate = await this.file.fileHandeleBase64(event);
  //     base64 = this.policeCertficate;
  //   } if (field == 'resume') {
  //     this.resume = await this.file.fileHandeleBase64(event);
  //     base64 = this.resume;
  //   }
  //   this.editDriverForm.controls[field].patchValue(base64);
  //   this.updateField(field, base64);
  // }

  // reUpload(field) {
  //   document.getElementById(field).click();
  // }

  async handleUpload(event: Event, type: string) {
    const file = (event.target as HTMLInputElement).files?.[0];
    const maxFileSizeInMB = 1;
    const maxFileSize = maxFileSizeInMB * 1024 * 1024;
    const allowedImageTypes = ["image/jpeg", "image/png", "image/gif"];
    const allowedPdfType = "application/pdf";

    if (!file) return;

    const fileType = file.type;
    const isImageOrPdf =
      allowedImageTypes.includes(fileType) || fileType === allowedPdfType;

    if (!isImageOrPdf) {
      this.handleInvalidFileType(type);
      return this.showErrorMessage(
        "Invalid file type. Only images and PDFs are allowed.",
      );
    }

    if (file.size > maxFileSize) {
      this.handleFileSizeExceeded(type);
      return this.showErrorMessage(`File size exceeds ${maxFileSizeInMB} MB`);
    }

    this.processFile(
      file,
      type,
      fileType,
      allowedImageTypes.includes(fileType) ? "Image" : "PDF",
    );

    // if (this.formSubmit) this.validation();
  }

  private processFile(
    file: File,
    type: string,
    fileType: string,
    contentType: string,
  ) {
    const fileReader = new FileReader();
    fileReader.onload = () =>
      this.updateFormAndPreview(
        type,
        file,
        fileReader.result as string,
        contentType,
      );
    fileReader.readAsDataURL(file);
  }

  private updateFormAndPreview(
    type: string,
    file: File,
    previewData: string,
    contentType: string,
  ) {
    switch (type) {
      case "profilePic":
        this.profileImage = file;
        this.profilePreview = previewData;
        this.profileContentFile = contentType;
        // this.updateField('profile', this.profilePreview)
        this.profileUpdate = true;
        this.editDriverForm.controls.profilePic.patchValue(file);
        break;
      case "licenceUpload":
        this.licenceImage = file;
        this.licenceUploadContentFile = contentType;
        this.licencePreview = previewData;
        // this.updateField('profile', this.profilePreview)
        this.licenceUpdate = true;
        this.editDriverForm.controls.licenceUpload.patchValue(file);
        break;
      case "addressProof":
        this.addressProof = file;
        this.addressContentFile = contentType;
        this.addressProofPreview = previewData;
        // this.updateField('addressfiles', this.addressProofPreview)
        this.addressUpdate = true;
        this.editDriverForm.controls.addressProof.patchValue(file);
        break;
      case "policeCertficate":
        this.policeCertficate = file;
        this.policeCertficateContentFile = contentType;
        this.policeCertficatePreview = previewData;
        this.policeCertficateUpdate = true;
        this.editDriverForm.controls.policeCertficate.patchValue(file);
        break;
      case "resume":
        this.resume = file;
        this.resumeContentFile = contentType;
        this.resumePreview = previewData;
        // this.updateField('resumefiles', this.resumePreview)
        this.resumeUpdate = true;
        this.editDriverForm.controls.resume.patchValue(file);
        break;
      case "antecedentReport":
        this.antecedentReport = file;
        this.antecedentContentFile = contentType;
        this.antecedentReportPreview = previewData;
        this.antecedentReportUpdate = true;
        this.editDriverForm.controls.antecedentReport.patchValue(file);
        break;
    }
  }

  private handleInvalidFileType(type: string) {
    this.resetFileFields(type);
  }

  private handleFileSizeExceeded(type: string) {
    this.resetFileFields(type);
  }

  private resetFileFields(type: string) {
    switch (type) {
      case "profilePic":
        this.profileImage = null;
        this.profilePreview = null;
        this.profileContentFile = null;
        this.editDriverForm.controls.profilePic.reset();
        this.clearInputField(this.profile);
        break;
      case "licenceUpload":
        this.licenceImage = null;
        this.licencePreview = null;
        this.licenceUploadContentFile = null;
        this.editDriverForm.controls.licenceUpload.reset();
        this.clearInputField(this.licence);
        break;
      case "addressProof":
        this.addressProof = null;
        this.addressProofPreview = null;
        this.addressContentFile = null;
        this.editDriverForm.controls.addressProof.reset();
        this.clearInputField(this.address);
        break;
      case "policeCertficate":
        this.policeCertficate = null;
        this.policeCertficatePreview = null;
        this.policeCertficateContentFile = null;
        this.editDriverForm.controls.policeCertficate.reset();
        this.clearInputField(this.policeCert);
        break;
      case "resume":
        this.resume = null;
        this.resumePreview = null;
        this.resumeContentFile = null;
        this.editDriverForm.controls.resume.reset();
        this.clearInputField(this.resum);
        break;
      case "antecedentReport":
        this.antecedentReport = null;
        this.antecedentReportPreview = null;
        this.antecedentContentFile = null;
        this.editDriverForm.controls.antecedentReport.reset();
        this.clearInputField(this.antecedent);
        break;
    }
  }

  private clearInputField(inputElement: ElementRef) {
    if (inputElement) inputElement.nativeElement.value = "";
  }

  private showErrorMessage(message: string) {
    this.swal.swalFunction("error", "error", message, 5000);
  }

  reUpload(field: string) {
    const fileFieldMap = {
      profile: this.profile,
      licence: this.licence,
      address: this.address,
      policeCert: this.policeCert,
      resum: this.resum,
      antecedent: this.antecedent,
    };

    const fileInput = fileFieldMap[field];
    if (fileInput) {
      fileInput.nativeElement.click();
    }
  }

  cancelImage(type: string) {
    if (type == "profile") {
      this.editDriverForm.controls.profilePic.patchValue("");
      this.profileImage = undefined;
    }
    if (type == "licenceUpload") {
      this.editDriverForm.controls.licenceUpload.patchValue("");
      this.licenceImage = undefined;
    }
    if (type == "addressProof") {
      this.editDriverForm.controls.addressProof.patchValue("");
      this.addressProof = undefined;
    }
    if (type == "policeCertficate") {
      this.editDriverForm.controls.policeCertficate.patchValue("");
      this.policeCertficate = undefined;
    }
    if (type == "resume") {
      this.editDriverForm.controls.resume.patchValue("");
      this.resume = undefined;
    }
    if (type == "antecedentReport") {
      this.editDriverForm.controls.antecedentReport.patchValue("");
      this.antecedentReport = undefined;
    }
  }

  /*update field*/
  fieldChange(e: any, type, field) {
    if (type == "text" || type == "textarea" || type == "number") {
      let value = e.target.value;
      if ((field == "mobile" || field == "emergencyContact") && value != "")
        value = parseInt(value);
      this.updateField(field, value);
    }
    if (type == "date") {
      let value = new Date(e.value).getTime();
      this.updateField(field, value);
    }
    if (type == "dropdown") {
      this.updateField(field, e.value);
    }
    if (type == "file") {
      // console.log(e);
      //this.fileUpload(e,field);
    }
    if (type == "option") {
      // console.log(e.option.value.name);
    }
  }
  updateField(field, value) {
    if (this.updateValues.length > 0) {
      let filterUpdate = this.updateValues.filter((e) => e.field != field);
      let obj = { field: field, value: value };
      this.updateValues = [...filterUpdate, obj];
    } else {
      let obj = { field: field, value: value };
      this.updateValues.push(obj);
    }
  }

  onSubmit() {
    this.finalCheck = true;
    if (
      (this.updateValues.length > 0 && this.editDriverForm.valid) ||
      this.policeCertficateUpdate ||
      this.profileUpdate ||
      this.licenceUpdate ||
      this.addressUpdate ||
      this.resumeUpdate ||
      this.antecedentReportUpdate
    ) {
      const obj = {
        orgID: this.orgID,
        vendorID: this.vendorID,
        driverID: this.driverID,
      };
      this.updateValues.filter((e) => {
        obj[e.field] = e.value;
      });
      if (
        this.profileImage == undefined ||
        (obj["profilePic"] && obj["profilePic"] == "")
      )
        delete obj["profilePic"];

      // if (this.profileUpdate == true) {
      //   obj['profile'] = this.profileImage;
      //   obj['profileContentFile'] = this.profileContentFile;
      //   delete obj['profilePic']
      // } else { delete obj['profilePic'] }

      if (this.profileUpdate === true && this.profileImage instanceof File) {
        obj["profile"] = this.profileImage;
        obj["profileContentFile"] = this.profileContentFile;
        delete obj["profilePic"];
      } else {
        delete obj["profile"];
        delete obj["profileContentFile"];
        delete obj["profilePic"];
      }

      if (this.licenceUpdate == true) {
        obj["licenceUpload"] = this.licenceImage;
        obj["licenceUploadContentFile"] = this.licenceUploadContentFile;
      } else {
        delete obj["licenceUpload"];
      }

      if (this.policeCertficateUpdate == true) {
        obj["policeCertficate"] = this.policeCertficate;
        obj["policeCertficateContentFile"] = this.policeCertficateContentFile;
      } else {
        delete obj["policeCertficate"];
      }
      if (this.resumeUpdate == true) {
        obj["resumefiles"] = this.resume;
        obj["resumeContentFile"] = this.resumeContentFile;
        delete obj["resume"];
      } else {
        delete obj["resumefiles"];
        delete obj["resume"];
      }
      if (this.addressUpdate == true) {
        obj["addressfiles"] = this.addressProof;
        obj["addressContentFile"] = this.addressContentFile;
        delete obj["addressProof"];
      } else {
        delete obj["addressProof"];
      }
      if (this.antecedentReportUpdate == true) {
        obj["antecedentReport"] = this.antecedentReport;
        obj["antecedentContentFile"] = this.antecedentContentFile;
      }
      let url = "organization/driver/updateDriver";
      this.api.transportManagerFormDataCreate(obj, url, (res: any) => {
        if (res["responseJSON"]["status"] == "success") {
          this.profileImage = undefined;
          this.licenceImage = undefined;
          this.addressProof = undefined;
          this.policeCertficate = undefined;
          this.resume = undefined;
          this.swal.swalFunction(
            res["responseJSON"].status,
            res["responseJSON"].status,
            res["responseJSON"].message,
            2000,
          );
          this.router.navigate([
            "/organization/transport-manager/information/driver/view-driver",
            this.vendorID,
          ]);
        }
        if (res["responseJSON"].status == "failure") {
          this.loader.hide();
          this.swal.swalFunction(
            "error",
            res["responseJSON"].status,
            res["responseJSON"].message,
            3000,
          );
        }
      });
    } else {
      if (this.updateValues.length == 0) {
        this.swal.swalFunction(
          "warning",
          "warning",
          "Please make any change and update!",
          6000,
        );
      }
    }
  }
  previewImage(imageUrl) {
    // this.imageUrl = image;
    if (imageUrl.startsWith("data:image")) {
      // Open the base64 image in a new tab
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`<img src="${imageUrl}" style="width:100%;">`);
        newWindow.document.title = "Image Preview";
      }
    } else {
      window.open(imageUrl, "_blank");
    }
  }

  openPdf(pdfUrl: string) {
    if (pdfUrl.startsWith("data:application/pdf;base64,")) {
      const newWindow = window.open();
      if (newWindow) {
        newWindow.document.write(`
          <html>
            <head>
              <title>PDF Preview</title>
            </head>
            <body style="margin: 0; padding: 0; overflow: hidden;">
              <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" />
            </body>
          </html>
        `);
      }
    } else {
      // Handle URL-based PDF
      window.open(pdfUrl, "_blank");
    }
  }
}
